import axios from "axios";
import DOMPurify from "dompurify"; // Import DOMPurify
import React, { Component } from "react";

const SPRITEMAP_FILE_NAME = "spritemap.svg";

class SvgSpritemap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spritemap: null,
    };
  }

  componentDidMount() {
    this.loadSpritemap();
  }

  async loadSpritemap() {
    const publicPath = "/";
    let url = `${publicPath}${SPRITEMAP_FILE_NAME}`;
    await axios.get(url).then((response) => {
      const sanitizedSpritemap = DOMPurify.sanitize(response?.data);
      this.setState({ spritemap: sanitizedSpritemap });
    });
  }

  render() {
    const { spritemap } = this.state;
    return (
      <React.Fragment>
        <div
          id="spritemapWrapper"
          dangerouslySetInnerHTML={{ __html: spritemap }}
        />
      </React.Fragment>
    );
  }
}

export default SvgSpritemap;
